import { render, staticRenderFns } from "./MapSankey.vue?vue&type=template&id=1274bf31&"
import script from "./MapSankey.vue?vue&type=script&lang=js&"
export * from "./MapSankey.vue?vue&type=script&lang=js&"
import style0 from "./MapSankey.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports